<template>
  <DropdownField
    inputId="mealplan-type"
    :name="name"
    :label="t('sites.singleSite.financialConfig.mealPlans.form.planType')"
    :placeholder="t('sites.singleSite.financialConfig.mealPlans.form.planTypePlaceholder')"
    :options="mealPlanTypes"
    optionLabel="label"
    optionValue="value"
    @change="setInitialValues($event?.value)"
    required
    :disabled="disabled"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useMealPlan } from '../../composables';
import { storeToRefs } from 'pinia';
import { useFormStore } from '@centric-os/stores/form/use-form-store';
import { useSiteStore } from '@centric-os/stores/sites/use-site-store';
import ID from '@compassdigital/id';
import {
  ATRIUM_TYPES,
  CBORD_TYPES,
  DEFAULT_VENDOR_IDs,
  FinancialFormIDs,
  ITC_TYPES,
  MEALPLAN_TYPES,
  TENDER_TYPES,
  TRANSACT_TYPES,
} from '../../../enums';

// Set localization
const { t } = useI18n();

// Set meal plan composable
const { mealPlanTypes } = useMealPlan();

// Set form store
const formStore = useFormStore();
const form = formStore.getForm(FinancialFormIDs.MEAL_PLAN_FORM);

defineProps({
  name: {
    type: String,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

// Set initial values for meal plan
const setInitialValues = (type: string): void => {
  // Set site store
  const siteStore = useSiteStore();
  const { site } = storeToRefs(siteStore);

  if (type !== MEALPLAN_TYPES.HEARTLAND) {
    if (CBORD_TYPES.includes(type)) {
      // @ts-expect-error FIXME: Argument of type 'string' is not assignable to parameter of type 'never'.
      form.value?.setFieldValue('id', ID('mealplan', 'cbord', 'mealplan', site.value?.id));
      // @ts-expect-error FIXME: Argument of type 'string' is not assignable to parameter of type 'never'.
      form.value?.setFieldValue('tenders', [{ name: '', type: '', tax_exempt: false }]);
    }

    if (ITC_TYPES.includes(type)) {
      // @ts-expect-error FIXME: Argument of type 'string' is not assignable to parameter of type 'never'.
      form.value?.setFieldValue('id', ID('mealplan', 'itc', 'mealplan', site.value?.id));
      // @ts-expect-error FIXME: Argument of type 'string' is not assignable to parameter of type 'never'.
      form.value?.setFieldValue('name', 'ITC');
      // @ts-expect-error FIXME: Argument of type 'string' is not assignable to parameter of type 'never'.
      form.value?.setFieldValue('keystore.vendor_id', DEFAULT_VENDOR_IDs.ITC);
      // @ts-expect-error FIXME: Argument of type 'string' is not assignable to parameter of type 'never'.
      form.value?.setFieldValue('tenders', [
        {
          name: '',
          type: TENDER_TYPES.DECLINING_BALANCE,
          tax_exempt: false,
          tender_number: '',
        },
      ]);
    }

    if (TRANSACT_TYPES.includes(type)) {
      // @ts-expect-error FIXME: Argument of type 'string' is not assignable to parameter of type 'never'.
      form.value?.setFieldValue('id', ID('mealplan', 'blackboard', 'mealplan', site.value?.id));
      // @ts-expect-error FIXME: Argument of type 'string' is not assignable to parameter of type 'never'.
      form.value?.setFieldValue('name', 'TRANSACT');
      // @ts-expect-error FIXME: Argument of type 'string' is not assignable to parameter of type 'never'.
      form.value?.setFieldValue('valid_email_domains', []);
      // @ts-expect-error FIXME: Argument of type 'string' is not assignable to parameter of type 'never'.
      form.value?.setFieldValue('tenders', [
        {
          name: '',
          type: TENDER_TYPES.DECLINING_BALANCE,
          tax_exempt: false,
          tender_number: '',
        },
      ]);
    }

    if (ATRIUM_TYPES.includes(type)) {
      // @ts-expect-error FIXME: Argument of type 'string' is not assignable to parameter of type 'never'.
      form.value?.setFieldValue('id', ID('mealplan', 'atrium', 'mealplan', site.value?.id));
      // @ts-expect-error FIXME: Argument of type 'string' is not assignable to parameter of type 'never'.
      form.value?.setFieldValue('name', 'ATRIUM');
      // @ts-expect-error FIXME: Argument of type 'string' is not assignable to parameter of type 'never'.
      form.value?.setFieldValue('valid_email_domains', []);
      // @ts-expect-error FIXME: Argument of type 'string' is not assignable to parameter of type 'never'.
      form.value?.setFieldValue('tenders', [{ name: '', type: '', tax_exempt: false }]);
    }
  } else if (type === MEALPLAN_TYPES.HEARTLAND) {
    // @ts-expect-error FIXME: Argument of type 'string' is not assignable to parameter of type 'never'.
    form.value?.setFieldValue('id', ID('mealplan', 'heartland', 'mealplan', site.value?.id));
    // @ts-expect-error FIXME: Argument of type 'string' is not assignable to parameter of type 'never'.
    form.value?.setFieldValue('tax_exempt', false);
    // @ts-expect-error FIXME: Argument of type 'string' is not assignable to parameter of type 'never'.
    form.value?.setFieldValue('tenders', [
      { id: '1', tender_numer: ID('mealplan', type, 'tender', '1'), tax_exempt: false },
    ]);
  }
};
</script>
